module.exports = __webpack_public_path__ + "static/media/logo.767175ea.svg";